export interface Transaction  {
    id: number;
    date: string|Date;
    type: string;
    friendlyTransactionType: string;
    contractId: string;
    contractNumber: string;
    usageYear: number;
    usageType: string;
    friendlyUsageType: string;
    amount: number;
    description: string
};

export interface TransactionHistoryResult {
    transactions: Transaction[];
    filters: {
        transactionYears: string[];
        transactionTypes: string[];
        contracts: string[];
        usageYears: number[];
        usageTypes: string[];
        userName: string[];
    }
}

export enum TransactionType {
    RESERVATION = "Reservation"
}

export enum TransactionHistoryType {
    BY_USAGE = "BY_USAGE",
    BY_TRANSACTION = "BY_TRANSACTION"
}

